module.exports = __webpack_public_path__ + "img/w4.49e404a5.jpg";